import React from 'react'
import { Text, View } from 'react-native';
import { StyleSheet } from 'react-native-unistyles';

const SectionTitle = ({ title, fontSize = 12, marginLeft = 0, marginTop = 20, fullColor = false }) => {

    return (
        <View style={styles.container(marginLeft, marginTop)}>
            <Text numberOfLines={1} style={styles.text(fontSize, fullColor)}>{title}</Text>
        </View>
    )
}

const styles = StyleSheet.create(({colors, fonts}) => ({
    container: (marginLeft, marginTop) => ({
        justifyContent:"center", 
        alignItems:"left", 
        marginBottom:5,
        marginTop:marginTop,
        marginLeft:marginLeft
    }),
    text: (fontSize, fullColor) => ({
        fontSize:fontSize, 
        color:colors.textSecondary,
        opacity:fullColor ? 1 : 0.6,
        fontFamily:fonts.heading, 
        textTransform:"uppercase", 
        zIndex:1
    })
}));

export default React.memo(SectionTitle)

